module.exports = __webpack_public_path__ + "img/box2_tag3.8bfdbb9f.png";